import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FAQ() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);
  const items = t("faq.items");

  return (
    <section id="faq" className="scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8" data-testid="faq-section">
      <div className="mx-auto max-w-4xl">
        <SectionHeader kicker={t("faq.kicker")} title={t("faq.title")} id="faq" />
        <div className="divide-y divide-red-900/25 rounded-2xl border border-red-900/30 bg-[#0D0608]">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} data-testid={`faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                  data-testid={`faq-question-${i}`}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-red-950/20"
                >
                  <span className={`text-sm font-semibold sm:text-base ${isOpen ? "text-yellow-400" : "text-zinc-100"}`}>
                    {item.q}
                  </span>
                  <ChevronDown
                    size={18}
                    aria-hidden="true"
                    className={`shrink-0 text-red-500 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-panel-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="break-words px-6 pb-6 text-sm leading-relaxed text-zinc-400" data-testid={`faq-answer-${i}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
